// extracted by mini-css-extract-plugin
export default {"root":"_18GRP","content-root":"Bg0tU","contentRoot":"Bg0tU"};